import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const SVG = styled.svg`
  & path {
    stroke: ${({ color }) => themeGet(`colors.${color}`)};
  }
`;

const CheckSVG = ({ color }) => (
  <SVG
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
  >
    <path
      d="M10 3.31848L4.5 8.81848L2 6.31848"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVG>
);

export default CheckSVG;
